export default function Sprig({ className = "", style }) {
    return (
        <svg
            viewBox="0 0 60 120"
            fill="none"
            aria-hidden="true"
            className={className}
            style={style}
        >
            <path
                d="M32 116 C30 88 30 48 34 6"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
            />
            <path
                d="M31.5 92 C20 88 13 79 12 66 C23 71 30 80 31.5 92Z"
                fill="currentColor"
            />
            <path
                d="M32 68 C42 63 47 54 47 42 C37 47 32 56 32 68Z"
                fill="currentColor"
                opacity="0.8"
            />
            <path
                d="M32.5 46 C23 41 19 33 19 22 C28 26 32 34 32.5 46Z"
                fill="currentColor"
                opacity="0.65"
            />
            <path
                d="M33.5 28 C42 24 45 17 45 8 C37 11 34 18 33.5 28Z"
                fill="currentColor"
                opacity="0.5"
            />
        </svg>
    );
}
